/**
 * MODULES - custom recaptcha delay
 * @author PLEJ
 */
import {validation} from "./validation";

const recaptchaDelay = (() => {
    const allRecaptchas = [];
    const isForm = document.querySelector("form");
    const init = () => {
        setTimeout( () => {
            if(isForm) appendScript();
        },2000);
    };

    const appendScript = () => {
        const script = document.createElement("script");
        script.src = 'https://www.google.com/recaptcha/api.js?onload=onloadCallback&render=explicit';
        script.async = true;
        script.defer = true;
        document.body.appendChild(script);
    };

    const onSuccess = () => {
        validation.recaptchaSuccess();
    }

    const onloadCallback = () => {
        const captchas = document.querySelectorAll(".g-recaptcha");

        captchas.forEach(captcha => {
            const temp = grecaptcha.render(captcha, {
                'sitekey': '6Ld16YAqAAAAAPGfZxQl6ACYKBQ5MXdwdkGk0mBm',
                'callback': onSuccess
            });

            allRecaptchas.push(temp);
        })
    };

    return {
        init,
        allRecaptchas,
        onloadCallback
    };
})();

window.onloadCallback = recaptchaDelay.onloadCallback;
window.allRecaptchas = recaptchaDelay.allRecaptchas;

export {recaptchaDelay};
